class ProductCard extends HTMLElement {
    constructor() {
        super();
        this.wishlist = window.GLOBAL?.wishlist;
        this.wishlistItem = null;

        this.wishlistBtn = this.nextElementSibling ? this.nextElementSibling.querySelector(".js-wishlist-btn") : this.querySelector(".js-wishlist-btn");
        this.heartFill = this.nextElementSibling ? this.nextElementSibling.querySelector(".heart-fill") : this.querySelector(".heart-fill");

        if(this.wishlistBtn){
            this.wishlistBtn.addEventListener(
                "click",
                this.addToWishlistClickHandler.bind(this)
            );
        }

        window.GLOBAL.wishlist && this.handleWishlistLoaded({ detail: window.GLOBAL.wishlist });
        window.document.addEventListener('wishlistLoaded', this.handleWishlistLoaded.bind(this));

    }

    async addToWishlistClickHandler(event) {
        event.preventDefault();

        const variantId = this.dataset.variantId;
        const customerId = window.GLOBAL.customerId;
        const productId = this.dataset.id;
        const handle = this.dataset.handle;
        const wishListItemId = this.wishlistItem?.WishListItemID;
        const qty = 1;

        if (!customerId) {
            return window.location.replace(window.GLOBAL.routes.account_login_url);
        }

        try {
            if (!wishListItemId) {
                await addToWishlist({
                    customerId,
                    productId,
                    handle,
                    variantId,
                    qty,
                });

                // const productData = JSON.parse(
                //     decodeURIComponent(this.dataset.datalayerProduct)
                // );
                // const productIndex = this.dataset.index;
                // productData.index = productIndex || 0;
                // productData.item_list_id = handleize(this.dataset.placement);
                // productData.item_list_name = this.dataset.placement;

                // pushAddToWishlist(productData);
            } else {
                await removeFromWishlist({
                    customerId,
                    wishListItemId,
                });
            }
            await this.refreshWishlist();
        } catch (error) {
            console.error(error);
        }
    }

    handleWishlistLoaded({ detail }) {
        this.wishlist = detail.data
        this.wishlistItem = this.findWishlistItem()
        this.updateHeartFill()
    }

    async refreshWishlist() {
        window.GLOBAL.wishlist = await getWishlist()
        const event = new window.CustomEvent('wishlistLoaded', { detail: window.GLOBAL.wishlist })
        window.document.dispatchEvent(event)
    }

    findWishlistItem() {
        if (!this.wishlist) {
            return
        }

        const productId = this.dataset.id
        return this.wishlist.find(({ ProductID }) => ProductID === productId)
    }

    updateHeartFill() {
        if (!this.heartFill || !this.wishlist) {
            return
        }

        if (!this.wishlistItem) {
            this.heartFill.style.fill = 'none';
            this.heartFill.classList.remove('heart-filled')
            return
        }

        this.heartFill.style.fill = '#fff';
        this.heartFill.classList.add('heart-filled')
    }
}

customElements.define("product-card", ProductCard);
